import React from 'react';

/**
 * Colored bullet indicator for menu items.
 * @param {{ type?: 'veg' | 'nonveg' }} props
 */
const Bullet = ({ type = 'veg' }) => (
  <span
    className={`fm-bullet ${type === 'nonveg' ? 'fm-bullet--nonveg' : 'fm-bullet--veg'}`}
    aria-hidden="true"
  >
    •
  </span>
);

export default React.memo(Bullet);
